import Backbone from 'backbone';
import Controller from 'controller';
import 'debug/client-version-header';
import trackQuickloadEvent from 'debug/trackQuickloadEvent';
import Dates from 'lib/dates';
import Monitor from 'lib/monitor';
import WindowSize from 'lib/window-size';
import SessionStatus from 'network/session-status';
import ModelCache from 'scripts/db/model-cache';
import subscribeToLiveUpdates from 'scripts/init/live-updater';

// Extend jQuery with the format and formatHtml methods
import 'lib/jquery-localize';

let elem = null;
let firstTime = true;

function initClient() {
  appendElem();

  if (!firstTime) {
    Backbone.history.start({ pushState: true });

    return;
  }

  setInterval(() => {
    Dates.update('#classic-body');
    Dates.trigger('renderInterval');
  }, 10 * 1000);

  SessionStatus.start();
  Monitor.init();
  Controller.start().then(() => {
    Backbone.history.start({ pushState: true });
  });
  WindowSize.ensureRun();

  QuickLoad.onRemove((preloadObj) => {
    if (!preloadObj.used) {
      trackQuickloadEvent('quickload unused', preloadObj.url);
    }
  });

  subscribeToLiveUpdates(({ typeName, delta }) => {
    ModelCache.enqueueRpcDelta(typeName, delta);
  });

  firstTime = false;
}

export function bootstrap() {
  return Promise.resolve();
}

export function mount() {
  return Promise.resolve().then(() => {
    // re-enable Trello classic styles if coming from Gamma
    const coreStyles = document.querySelector(
      'link[rel="stylesheet"][href*="core"]',
    );
    if (coreStyles && coreStyles.disabled) {
      coreStyles.disabled = false;
    }

    initClient();
  });
}

export function unmount() {
  return Promise.resolve().then(() => Backbone.history.stop());
}

export const timeouts = {
  bootstrap: { millis: 5000 },
  mount: { millis: 5000 },
  unmount: { millis: 5000 },
  unload: { millis: 5000 },
};

export function setElem(el) {
  elem = el;
}

export function appendElem() {
  if (document.getElementById('classic')) {
    return;
  }

  const classicContainer = document.getElementById('classic-body');
  classicContainer.appendChild(elem);
  // make sure we're not hiding this container anymore (see #removeElem)
  classicContainer.classList.remove('hideContainer');
}

export function removeElem() {
  if (!elem) {
    return;
  }

  elem.remove();

  // hide the container so that it's 100% height no longer negatively
  // impacts react-beautiful-dnd's window.scrollTo() use
  document.getElementById('classic-body').classList.add('hideContainer');
}



// WEBPACK FOOTER //
// ./app/scripts/singlespa/apps/classic.js